(function(){
angular.module('charts')
  .directive('edxStudentRecentActivityList', function() {
    return {
      restrict: 'E',
      scope: {
        student: '=edxStudent'
      },
      templateUrl: '/resources/right-pane/components/student-overview/student-recent-activity-list.directive.html',
      bindToController: true,
      controllerAs: 'vm',
      controller: [
        '$scope',
        '$rootScope',
        '$state',
        'timeframe',
        'activityApi',
        'dblStudentMilestonesService',
        'reportErrors',
        'authentication',
        'configuration',
        EdxStudentRecentActivityListController]
    };
  });

  function EdxStudentRecentActivityListController(
    $scope,
    $rootScope,
    $state,
    timeframe,
    activityApi,
    dblStudentMilestonesService,
    reportErrors,
    authentication,
    configuration
  ) {
    var vm = this;

    /** Number of days, including today, of activity to show */
    var ACTIVITY_TRAILING_DAYS = 7;

    vm.displayWarning = displayWarning;
    vm.useNewAlerts = useNewAlerts;

    _onInit();

    function _onInit() {
      var dereg1 = $rootScope.$on('timeframeSelected', _reloadActivity);
      var dereg2 = $rootScope.$on('timeframeInitialized', _reloadActivity);
      $scope.$watch('vm.student', _reloadActivity);
      $scope.$on('$destroy', function() {
        dereg1();
        dereg2();
      });
    }

    /**
     * Determine if we should display a warning that the recent activity doesn't reflect the complete timeframe selected
     *
     * @return {boolean|*}
     */
    function displayWarning() {
      return vm._displayWarning;
    }

    /**
     * Determine if we are using the new EFP alerts or classic alerts
     *
     * @return {*}
     */
    function useNewAlerts() {
      return authentication.getCustomer().hasTag('INSIGHT_EFP') && configuration.isFeatureEnabled('alerts_efp_enabled');
    }

    /**
     * Reload activity and milestones
     *
     * @private
     */
    function _reloadActivity() {
      var districtId, studentId, timeframeWithin30, days, fd, td;

      districtId = $state.params.districtId;
      if (!districtId) {
        return;
      }

      if (!vm.student) {
        return;
      }
      studentId = vm.student.id;

      if (useNewAlerts()) {
        days = ACTIVITY_TRAILING_DAYS;
        fd = '';
        td = '';
      } else {
        vm._displayWarning = !timeframe.isWithinDays(30);
        timeframeWithin30 = timeframe.getTimeframeWithinDays(30);

        if (!timeframeWithin30) {
          // timeframe doesn't overlap last 30 days at all, so don't bother requesting activities
          vm.milestones = undefined;
          vm.milestonesMessage = dblStudentMilestonesService.NO_ACTIVITY_MESSAGE;
          return;
        }

        days = timeframeWithin30.days;
        fd = timeframeWithin30.fd;
        td = timeframeWithin30.td;
      }

      // reset infinite scrolling if active
      vm.milestonesMessage = undefined;
      vm.milestones = undefined;

      activityApi.getStudentActivities(districtId, studentId, days, fd, td, true).then(function(data) {
        vm.milestones = dblStudentMilestonesService.getMilestones(data.activities);
        if (!vm.milestones.length) {
          if (useNewAlerts()) {
            vm.milestonesMessage = 'No activity in the last ' + ACTIVITY_TRAILING_DAYS + ' days.';
          } else {
            vm.milestonesMessage = dblStudentMilestonesService.NO_ACTIVITY_MESSAGE;
          }
        }
      }, function(error) {
        vm.milestones = undefined;
        vm.milestonesMessage = reportErrors.getErrorMessage(error, 'Unable to load activity.');
      });
    }

  }
})();
